import { IProduct } from "../interfaces/product.interface";

export class Product implements IProduct {
  productpk: number;
  productName: string;
  productFamilyPk: number;

  constructor(product: IProduct) {
    Object.keys(product).map(key => this[key] = product[key]);
}
}
